import { getUserSession } from './getUserSession.helper'

export const getCookie = (cname: string) => {
  // Development only
  if (
    (!process.env.NODE_ENV ||
      process.env.NODE_ENV === 'development' ||
      process.env.NODE_ENV === 'test') &&
    process.env.REACT_APP_LOCAL_JWT
  ) {
    document.cookie = `${cname}=${process.env.REACT_APP_LOCAL_JWT}`
    return process.env.REACT_APP_LOCAL_JWT
  }

  const name = `${cname}=`
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }

  return ''
}

export const getHomeUri = (): string => {
  return angularUri(process.env.REACT_APP_HOME_URL as string)
}

export const getLoginUri = (): string => {
  return angularUri(process.env.REACT_APP_LOGIN_URL as string)
}

export const angularUri = (url: string): string => {
  return url
}

export const cookiesKiller = (cName: string) => {
  document.cookie = `${cName}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`
}

export const getJWT = () =>
  getCookie(process.env.REACT_APP_JWT_COOKIE as string)

export const getToken = () => getUserSession()
